import React, { FormEvent } from "react";

interface IFormInputTextProps {
  label: string;
  id: string;
  value?: string | undefined;
  required?: boolean | undefined;
  placeholder?: string | undefined;
  onChange: (id: string, value: string) => void;
  error?: string | undefined;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  hint?: string;
  disabled?: boolean;
  type?: string,
}

function FormInputText({
  label,
  id,
  value,
  required,
  disabled,
  placeholder,
  onChange,
  error,
  onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {},
  hint,
  type,
}: IFormInputTextProps) {
  const css: string = disabled ? "form-input-disabled" : "form-input";
  return (
    <div>
      <label htmlFor={id} className="form-label">
        {label}
        {required && <>*</>}
      </label>
      <input
        type={type ?? "text"}
        name={id}
        id={id}
        value={value}
        className={css}
        placeholder={placeholder}
        required={required}
        onChange={(e) => onChange(id, e.target.value)}
        onKeyDown={onKeyDown}
        disabled={disabled}
      />
      {hint && <div className="form-hint">{hint}</div>}
      {error && <div className="form-error">{error}</div>}
    </div>
  );
}

export default FormInputText;
